<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-05 10:24:48
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-09-10 15:57:09
 * @FilePath: \mrc-base-server-view\src\views\admin_account_manage\add\index.vue
-->
<template>
  <base-info
    @success="success"
    :disabled="false"
    :loading="loading"
    :successText="$t('label_submit')"
    @cancel="cancel"
  ></base-info>
</template>

<script>
import baseInfo from '../modules/baseInfo'
import { admin_account_add } from '@/service/api/admin_account_manage'
export default {
  components: { baseInfo },
  props: {},
  data() {
    return {
      loading: false,
    }
  },
  validations: {},
  computed: {},
  created() {},
  watch: {},
  mounted() {},

  methods: {
    async success(val) {
      const obj = this.$clone(val)
      if (obj.staffs_uuid) {
        delete obj.user_pwd
      }
      this.loading = true
      const res = await admin_account_add({
        ...obj,
        role_uuid: '002',
        login_url: this.$store.state.loginUrl,
      })

      if (res.code == 200) {
        this.$Message({ text: this.$t('message_The_operation_was_successful') })
        this.$router.go(-1)
      }
      this.loading = false
    },
    cancel() {
      this.$myConfirm({
        content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      })
        .then(() => {
          this.$router.go(-1)
        })
        .catch(() => {})
    },
  },
}
</script>

<style scoped></style>
